import React from 'react';
import { graphql } from 'gatsby';
import Img from 'gatsby-image';
import Slide from 'react-reveal/Slide';

import SEO from '../components/seo';

import { Menu, Item, ItemWithImage } from '../styles/styles.js';

const Porcoes = ({ data }) => {
  return (
    <>
      <SEO
        title="Pratos"
        keywords={[
          `Pratos`,
          `Batata`,
          `Batata com Bacon`,
          `filé de frango`,
          `Porção de Calabresa`,
        ]}
      />
      <Menu className="menu">
        <Slide left cascade>
          <h1 className="menu-title">Pratos Executivos</h1>
        </Slide>

        <ItemWithImage>
          <div className="item-image">
            <Img
              fluid={data.pratofile.childImageSharp.fluid}
              alt="Filé com Fritas"
            />
          </div>
          <div className="item-info">
            <div className="item-separator">
              <h4 className="item-title">Filé com Fritas</h4>

              <div className="item-price-wrapper">
                <h4 className="item-price">39,90</h4>
              </div>
            </div>
            <p className="item-desc">
              Arroz, feijão, salada, filé e batata frita.
            </p>
          </div>
        </ItemWithImage>

        <ItemWithImage>
          <div className="item-image">
            <Img
              fluid={data.pratofrango.childImageSharp.fluid}
              alt="Filé com Fritas"
            />
          </div>
          <div className="item-info">
            <div className="item-separator">
              <h4 className="item-title">Filé de Frango com Fritas</h4>

              <div className="item-price-wrapper">
                <h4 className="item-price">39,90</h4>
              </div>
            </div>
            <p className="item-desc">
              Arroz, feijão, salada, filé de frango e batata frita.
            </p>
          </div>
        </ItemWithImage>

        <ItemWithImage>
          <div className="item-image">
            <Img
              fluid={data.pratotilapia.childImageSharp.fluid}
              alt="Filé de Tilápia"
            />
          </div>
          <div className="item-info">
            <div className="item-separator">
              <h4 className="item-title">Filé de Tilápia</h4>

              <div className="item-price-wrapper">
                <h4 className="item-price">39,90</h4>
              </div>
            </div>
            <p className="item-desc">
              Arroz, feijão, salada, filé de tilápia e batata frita.
            </p>
          </div>
        </ItemWithImage>

        <ItemWithImage>
          <div className="item-image">
            <Img
              fluid={data.pratostrogonoff.childImageSharp.fluid}
              alt="Strogonoff de Carne"
            />
          </div>
          <div className="item-info">
            <div className="item-separator">
              <h4 className="item-title">Strogonoff de Carne</h4>

              <div className="item-price-wrapper">
                <h4 className="item-price">39,90</h4>
              </div>
            </div>

            <p className="item-desc">
              Arroz, salada, batata frita e strogonoff de carne.
            </p>
          </div>
        </ItemWithImage>

        <ItemWithImage>
          <div className="item-image">
            <Img
              fluid={data.pratopanquecastrogonoff.childImageSharp.fluid}
              alt="Strogonoff de Carne"
            />
          </div>
          <div className="item-info">
            <div className="item-separator">
              <h4 className="item-title">Panqueca com Strogonoff</h4>

              <div className="item-price-wrapper">
                <h4 className="item-price">39,90</h4>
              </div>
            </div>

            <p className="item-desc">
              Arroz, salada, batata frita e panqueca de strogonoff de carne.
            </p>
          </div>
        </ItemWithImage>

        <ItemWithImage>
          <div className="item-image">
            <Img
              fluid={data.pratopanquecasimples.childImageSharp.fluid}
              alt="Strogonoff de Carne"
            />
          </div>
          <div className="item-info">
            <div className="item-separator">
              <h4 className="item-title">Panqueca com Strogonoff Simples</h4>

              <div className="item-price-wrapper">
                <h4 className="item-price">29,90</h4>
              </div>
            </div>

            <p className="item-desc">
              Batata frita, batata palha e panqueca de strogonoff de carne.
            </p>
          </div>
        </ItemWithImage>

        <ItemWithImage>
          <div className="item-image">
            <Img
              fluid={data.pratokids.childImageSharp.fluid}
              alt="Prato Kids"
            />
          </div>
          <div className="item-info-">
            <div className="item-separator">
              <h4 className="item-title">Prato Kids</h4>

              <div className="item-price-wrapper">
                <h4 className="item-price">29,90</h4>
              </div>
            </div>

            <p className="item-desc">Arroz, filé e batata frita.</p>
          </div>
        </ItemWithImage>

        <Item>
          <div className="item-info-no-img">
            <div className="item-separator">
              <h4 className="item-title">Adicionais</h4>
              <div className="item-price-wrapper">
                <p className="item-price"></p>
              </div>
            </div>
            <p className="item-desc" />
            <ul className="item-options">
              <li>Arroz - R$ 10,00</li>
              <li>Feijão - R$ 10,00</li>
              <li>Salada - R$ 10,00 </li>
              <li>Ovo frito - R$ 5,00</li>
              <li>Filé de tilápia - R$ 22,00</li>
              <li>Filé - R$ 22,00</li>
              <li>Filé de frango - R$ 15,00</li>
              <li>Panqueca - R$ 25,00</li>
              <li>Molho de Alho - R$ 5,00</li>
              <li>Molho Verde - R$ 5,00</li>
            </ul>
          </div>
        </Item>
      </Menu>
    </>
  );
};

export const query = graphql`
  query {
    pratofile: file(relativePath: { eq: "prato-file.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 350, quality: 100) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
    pratofrango: file(relativePath: { eq: "prato-frango.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 350, quality: 100) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
    pratotilapia: file(relativePath: { eq: "prato-tilapia.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 350, quality: 100) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
    pratostrogonoff: file(relativePath: { eq: "prato-strogonoff.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 350, quality: 100) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
    pratopanquecastrogonoff: file(
      relativePath: { eq: "prato-panqueca-strogonoff.jpg" }
    ) {
      childImageSharp {
        fluid(maxWidth: 350, quality: 100) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
    pratopanquecasimples: file(
      relativePath: { eq: "prato-panqueca-simples.jpg" }
    ) {
      childImageSharp {
        fluid(maxWidth: 350, quality: 100) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
    pratokids: file(relativePath: { eq: "prato-kids.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 350, quality: 100) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
  }
`;

export default Porcoes;
